// Informations légales Noveocard — SEUL endroit à modifier.
// Tant qu'un champ vaut "[À COMPLÉTER]", il n'est pas affiché dans le schema.org
// et aucun balisage LocalBusiness n'est généré.

export const LEGAL = {
  operateur: "[À COMPLÉTER]", // Raison sociale / nom de l'exploitant
  formeJuridique: "[À COMPLÉTER]", // Ex : SASU, EURL, auto-entreprise…
  capital: "[À COMPLÉTER]", // Capital social (si applicable)
  siret: "[À COMPLÉTER]",
  adresse: "[À COMPLÉTER]",
  email: "[À COMPLÉTER]",
  tva: "[À COMPLÉTER]", // Numéro de TVA intracommunautaire (si applicable)
  hebergeur: "[À COMPLÉTER]", // Nom, adresse et téléphone de l'hébergeur
  directeurPublication: "[À COMPLÉTER]",
};

export const isLegalFieldSet = (value) =>
  Boolean(value) && value !== "[À COMPLÉTER]";

// LocalBusiness uniquement si les informations réelles sont fournies.
export const isLocalBusinessReady = () =>
  isLegalFieldSet(LEGAL.operateur) &&
  isLegalFieldSet(LEGAL.adresse) &&
  isLegalFieldSet(LEGAL.siret);
